angular.module('main').service('paymentVariablesService', () => {
	let plan;

	const setPlan = function(newObj) {
		plan = newObj;
	};
	const getPlan = function() {
		return plan;
	};

	return {
		setPlan,
		getPlan
	};
});



// WEBPACK FOOTER //
// ./web/js/services/paymentVariablesService.js